export default function IArrowRound({
  width = 24,
  height = 24,
  color = '#fff',
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M20.25 12C20.25 7.44365 16.5563 3.75 12 3.75C7.44365 3.75 3.75 7.44365 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25C16.5563 20.25 20.25 16.5563 20.25 12ZM21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12C2.25 6.61522 6.61522 2.25 12 2.25C17.3848 2.25 21.75 6.61522 21.75 12Z"
        fill={color}
      />
      <path
        d="M13.5303 8.46973C13.2557 8.19512 12.8209 8.17766 12.5264 8.41797L12.4697 8.46973L9.46973 11.4697C9.17683 11.7626 9.17683 12.2374 9.46973 12.5303L12.4697 15.5303C12.7626 15.8232 13.2374 15.8232 13.5303 15.5303C13.8232 15.2374 13.8232 14.7626 13.5303 14.4697L11.0605 12L13.5303 9.53027L13.582 9.47363C13.8223 9.17905 13.8049 8.74433 13.5303 8.46973Z"
        fill={color}
      />
    </svg>
  );
}
